(function($) {
  $(function() {
    $("[scroll-to-options-fitted]").click(function() {
      $('#fitted-options-tab').click();
      if( !$('#fitted-options .multi-collapse ').hasClass('show') ) {
        $('.features-toggle-collapse').click();
      };
      $('html, body').animate({
          scrollTop: $(".features").offset().top - 120
      }, 300);
    });
  });
})(jQuery);